import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
/** Router guard vb. setup dışı kullanım için paylaşılan Pinia instance */
export const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
